import { Helmet } from "react-helmet-async";

export const Seo = ({ title, description, path = "" }) => {
  const base = "Jonaren Technology";
  const fullTitle = title ? `${title} | ${base}` : `${base} | IT Services, Consulting & Enterprise Products`;
  const desc = description || "Jonaren Technology Pvt Ltd (JNT) - enterprise IT services, consulting, cloud, mobile, UX and AI-powered products since 2010. Offices in Bengaluru and Noida (Delhi-NCR), India.";
  const url = typeof window !== "undefined" ? `${window.location.origin}${path}` : path;
  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={desc} />
      <link rel="canonical" href={url} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={desc} />
      <meta property="og:type" content="website" />
      <meta property="og:url" content={url} />
      <meta property="og:image" content="/assets/logo.png" />
      <meta name="twitter:card" content="summary" />
    </Helmet>
  );
};
